<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <button onclick="javascript:location.href='../UIC/Country'" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
      </div>
      <div class="card-body">
        <table class="table table-sm table-bordered" id="myTable">
          <thead class="bg-custom">
            <tr>
              <th width="5%">Sr.</th>
              <th width="30%">Country Name</th>
              <th width="5%">Active</th>
              <th width="5%">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, ind) in list" :key="ind">
              <td>{{ ind + 1 }}</td>
              <td>{{ item.C_NAME }}</td>
              <!--<td>{{ item.C_ISACTIVE }}</td>-->
              <td><input type="checkbox" :checked="item.C_ISACTIVE == 1" disabled></td>

              <td>
                <button class="btn btn-primary btn-sm" @click="editcountry(item.C_CODE)"><i class="fas fa-pencil-alt" /></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    data() {
      return {
        list: [],
      };
    },

    created() {
      this.pageload();
    },
    updated() {
      $("#myTable").DataTable();
    },
    methods: {
      pageload() {
        var vm = this;
        startReq();
        axios.get('/api/UICApi/pageLoadCountryList')
          .then((res) => {
            endReq();
            if (res.data.status) {
              vm.list = res.data.list;
            } else {
              toastr.error(res.data.msg);
            }
          })
          .catch((error) => {
            endReq();
          });
      },
      editcountry(id) {
        window.open("/UIC/Country?id=" + id);
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ims/CountryList.vue